function parseISOString(s) {
  if(s) {
    var b = s.split(/\D+/);
    return new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5], b[6]));
  } else {
    return null;
  }
}

export function fmtDeltaFromDate(date1, date2=new Date()) {
  var d = Math.abs(date1 - date2) / 1000;
  var r = {};
  var s = {
    yr: 31536000,
    mo: 2592000,
    wk: 604800,
    day: 86400,
    hr: 3600,
    min: 60,
    sec: 1
  };

  Object.keys(s).forEach(function(key){
      r[key] = Math.floor(d / s[key]);
      d -= r[key] * s[key];
  });
  
  return(r);
}

export function fmtElapsedAgoFromIsoString(iso8601String) {
  try {
    return fmtElapsedFromDate(parseISOString(iso8601String)) + " ago";
  } catch(err) {
    return '';
  }
}

export function fmtElapsedFromIsoString(iso8601String) {
  try {
    return fmtElapsedFromDate(parseISOString(iso8601String));
  } catch(err) {
    return '';
  }
}

export function fmtElapsedFromDate(date, precision=2) {
  const deltaParts=fmtDeltaFromDate(date);
  const parts=['yr','mo','wk','day','hr','min','sec'];
  let resultParts=[];
  for( var i=0; i<parts.length; i++) {
    const part=parts[i];
    const value=deltaParts[part];
    
    if(value>0) {
      resultParts.push(value+" "+part+(value===1?'':'s'));
    }
    if(resultParts.length>=precision) {
      break;
    }
  }
  return resultParts.join(', ');
}
